import { GlobalAxios } from "../axios/axios-config";
import { IExamSendNonLabWorklistLog } from "../models/exam-send-non-lab-worklist-log";

const EXAM_SEND_NON_LAB_WORKLIST_Z_LOG_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/ExamSendNonLabWorklistZ/ExamSendNonLabWorklistZLog";

export const getExamSendNonLabWorklistZLog = (examSendIdentifier: number) => {
  return GlobalAxios.get<IExamSendNonLabWorklistLog>(
    EXAM_SEND_NON_LAB_WORKLIST_Z_LOG_ROUTE,
    {
      params: {
        examSendIdentifier,
      },
    },
  );
};
